import { createSelector } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import { TTicketManagementState } from './ticket-management.models';

export const getTicketManagementState = (state: TMachineMaintenanceState) => state.ticketManagementInfo;

export const getEmployeeTicketSummary = createSelector(
  getTicketManagementState,
  (state: TTicketManagementState) => state.employeeTicketSummary,
);

export const getTicketSummaryAnalytics = createSelector(
  getTicketManagementState,
  (state: TTicketManagementState) => state.ticketSummaryAnalytics,
);

export const getEmployeeTickets = createSelector(
  getTicketManagementState,
  (state: TTicketManagementState) => state.employeeTickets,
);

export const getEmployeeTicketDetails = createSelector(
  getTicketManagementState,
  (state: TTicketManagementState) => state.employeeTicketDetails,
);

export const getMachineTicketHistory = createSelector(
  getTicketManagementState,
  (state: TTicketManagementState) => state.machineTicketHistory,
);

export const getBreakdownReasonsAndSolution = createSelector(
  getTicketManagementState,
  (state: TTicketManagementState) => state.breakdownReasonsAndSolution,
);

export const getEmployeeRole = createSelector(
  getTicketManagementState,
  (state: TTicketManagementState) => state.employeeRole,
);

export const getFactoryShiftRevisionDetails = createSelector(
  getTicketManagementState,
  (state: TTicketManagementState) => state.factoryShiftDetails,
);

export const getMaintenanceTickets = createSelector(
  getTicketManagementState,
  (state: TTicketManagementState) => state.maintenanceTickets,
);

export const getSparePartRequestsBySource = createSelector(
  getTicketManagementState,
  (state: TTicketManagementState) => state.sparePartRequestsBySource,
);

export const getSparepartRequestReasons = createSelector(
  getTicketManagementState,
  (state: TTicketManagementState) => state.sparepartRequestReasons,
);

export const getEmployeeTicketsPagination = createSelector(
  getTicketManagementState,
  (state: TTicketManagementState) => state.employeeTicketsPagination,
);

export const getMaintenanceTicketsPagination = createSelector(
  getTicketManagementState,
  (state: TTicketManagementState) => state.maintenanceTicketsPagination,
);
